import { SfStarIcon } from 'fitify-ui/src/Icon/fill'
import { colors } from 'fitify-ui/src/theme/colors'
import type { DataTypes } from 'fitify-ui-landing/src/@types'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { useTranslation } from 'next-i18next'

import {
  StyledContainer,
  StyledHeader,
  StyledNameContainer,
  StyledStarContainer,
} from '@/components/blocks/Reviews/Review.Styled'

export type Props = DataTypes.ReviewItem

export const Review = ({ description, name, title }: Props) => {
  const { t } = useTranslation()

  return (
    <StyledContainer>
      <StyledHeader>
        {title ? (
          <Typography $color={colors.Black} $variant="Headline/H 16">
            {t(title)}
          </Typography>
        ) : null}
        <StyledNameContainer>
          <StyledStarContainer>
            <SfStarIcon />
            <SfStarIcon />
            <SfStarIcon />
            <SfStarIcon />
            <SfStarIcon />
          </StyledStarContainer>
          <Typography $color={colors.Gray600} $variant="Text/Body 16">
            {t(name)}
          </Typography>
        </StyledNameContainer>
      </StyledHeader>
      <Typography $color={colors.Gray600} $variant="Text/Body 16">
        {t(description)}
      </Typography>
    </StyledContainer>
  )
}
